export const TimeType = {
    Year: 'Year',
    Month: 'Month',
    Week: 'Week',
  }